export default "__VITE_ASSET__y$HpuGWI__"